import React from 'react'
import WorkExperienceCard from './WorkExperienceCard'

const WorkExperience = () => {
  return (
    <section id='WorkExperience'>
        <div className="experience-wrap">
            <h1>My Experiences</h1>
            <div className="experience-content">
                <WorkExperienceCard />
            </div>
        </div>
    </section>
  )
}

export default WorkExperience